import React, { Component } from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  IconButton,
  InputAdornment,
  FormControl,
  OutlinedInput,
  Button,
  DialogActions,
} from "@mui/material";


import { useNavigate } from "react-router-dom"; // Import useNavigate
import { ArrowLeft2, Eye, EyeSlash } from "iconsax-react";


const ProfilePage = (props) => {
  const navigate = useNavigate(); // Use the navigate hook
  const { login, passwordChange } = props;

  class Profile extends Component {
    constructor(props) {
      super(props);
      this.state = {
        currentPassword: "",
        newPassword: "",
        showPassword: false,
        confirmPassword: "",
      };
    }

    handleClickShowPassword = () => {
      this.setState((prevState) => ({
        showPassword: !prevState.showPassword,
      }));
    };

    handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    render() {
      const { showPassword, confirmPassword, currentPassword, newPassword } =
        this.state;

      return (
        <Grid>
          <Dialog open={true} maxWidth="xs" fullWidth>
            <DialogContent>
              <Button
                variant="text"
                sx={{
                  color: "#031634",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#e6f2ff" },
                }}
                onClick={() => navigate(-1)} // Navigate back
              >
                <ArrowLeft2 /> Back
              </Button>


              <DialogContent>
                <Typography
                  variant="h5"
                  textAlign={"center"}
                  mb={2}
                  style={{ color: "#031634", fontWeight: "bold" }}
                >
                  Change Password
                </Typography>


                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography style={{ color: "#333", fontSize: "14px" }}>
                      Current Password{" "}
                      <span style={{ color: "red", fontSize: "14px" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <OutlinedInput
                        type={showPassword ? "text" : "password"}
                        size="small"
                        value={currentPassword}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.handleClickShowPassword}
                              onMouseDown={this.handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <EyeSlash color="black" />
                              ) : (
                                <Eye color="black" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        onChange={(e) =>
                          this.setState({ currentPassword: e.target.value })
                        }
                        style={{ backgroundColor: "#fff", color: "#000" }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography style={{ color: "#333", fontSize: "14px" }}>
                      New Password{" "}
                      <span style={{ color: "red", fontSize: "14px" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <OutlinedInput
                        type={showPassword ? "text" : "password"}
                        size="small"
                        value={newPassword}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.handleClickShowPassword}
                              onMouseDown={this.handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <EyeSlash color="black" />
                              ) : (
                                <Eye color="black" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        onChange={(e) =>
                          this.setState({ newPassword: e.target.value })
                        }
                        style={{ backgroundColor: "#fff", color: "#000" }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography style={{ color: "#333", fontSize: "14px" }}>
                      Confirm New Password{" "}
                      <span style={{ color: "red", fontSize: "14px" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <OutlinedInput
                        type={showPassword ? "text" : "password"}
                        size="small"
                        value={confirmPassword}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.handleClickShowPassword}
                              onMouseDown={this.handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <EyeSlash color="black" />
                              ) : (
                                <Eye color="black" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        onChange={(e) =>
                          this.setState({ confirmPassword: e.target.value })
                        }
                        style={{ backgroundColor: "#fff", color: "#000" }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#031634",
                    color: "#fff",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#031634",
                    },
                  }}
                  onClick={() => {
                    if (newPassword !== confirmPassword) {
                      alert("New Password and Confirm Password do not match.");
                      return;
                    }
                    passwordChange(
                      login.token,
                      login.user_id,
                      currentPassword,
                      newPassword
                    );
                    this.setState({
                      currentPassword: "",
                      newPassword: "",
                      confirmPassword: "",
                    });
                  }}
                >
                  Update Password
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        </Grid>
      );
    }
  }

  return <Profile {...props} />;
};

export default ProfilePage;
